import { ACTION } from './authentication_actions';
import Constants from '../../config/constants';

const initialState = {
  loggedIn: localStorage.getItem('access-token') !== null,
  isInspector: localStorage.getItem('is_inspector') === 'true',
  isAuditor: localStorage.getItem('is_auditor') === 'true',
  isAdmin: localStorage.getItem('is_admin') === 'true',
  loggingIn: false,
  registering: false,
  resettingPwd: false,
  changingPwd: false,
  message: null,
  errorMessage: null,
};

export default (state = initialState, action) => {
  const actionType = action.type;

  switch (actionType) {
    case `${ACTION.LOGIN}_PENDING`:
      return {
        ...state,
        loggingIn: true,
        errorMessage: null,
      };
    case `${ACTION.LOGIN}_FULFILLED`:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        isInspector: action.payload.role.map(role => role.name)
          .indexOf(Constants.ROLES.INSPECTOR) !== -1,
        isAuditor: action.payload.role.map(role => role.name)
          .indexOf(Constants.ROLES.AUDITOR) !== -1,
        isAdmin: action.payload.is_staff === true,
      };
    case `${ACTION.LOGIN}_REJECTED`:
      return {
        ...state,
        loggingIn: false,
        errorMessage: action.payload,
      };
    case `${ACTION.LOGOUT}_FULFILLED`:
      return {
        ...state,
        loggedIn: false,
      };
    case `${ACTION.REGISTER}_PENDING`:
      return {
        ...state,
        registering: true,
        errorMessage: null,
      };
    case `${ACTION.REGISTER}_FULFILLED`:
      return {
        ...state,
        registering: false,
      };
    case `${ACTION.REGISTER}_REJECTED`:
      return {
        ...state,
        registering: false,
        errorMessage: action.payload,
      };
    case `${ACTION.RESETPASSWORD}_PENDING`:
      return {
        ...state,
        resettingPwd: true,
        errorMessage: null,
      };
    case `${ACTION.RESETPASSWORD}_FULFILLED`:
      return {
        ...state,
        resettingPwd: false,
        message: action.payload.message,
      };
    case `${ACTION.RESETPASSWORD}_REJECTED`:
      return {
        ...state,
        resettingPwd: false,
        errorMessage: action.payload,
      };
    case `${ACTION.SETPASSWORD}_PENDING`:
      return {
        ...state,
        changingPwd: true,
        errorMessage: null,
      };
    case `${ACTION.SETPASSWORD}_FULFILLED`:
      return {
        ...state,
        changingPwd: false,
      };
    case `${ACTION.SETPASSWORD}_REJECTED`:
      return {
        ...state,
        changingPwd: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CLEARERROR}_FULFILLED`:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/authentication/authentication_reducer.js